/* CO2Art — spin to win (sections/spin-to-win.liquid), 2026-09-16. Plan: co2art-ai docs/plans/2026-09-16-own-spin-to-win-KICKOFF.md (marketing R-NEW129).
   A side tab on browsing pages; the wheel opens on the tab's click — and, since 2026-09-19 (Karol's form 2026-09-18, co2art-ai plan
   docs/plans/2026-09-18-email-lifecycle-offers-PLAN.md track A1, amending his D6), ONCE per visitor by itself on exit intent: a desktop
   pointer leaving the page through the top, or on a phone (from the visitor's second page view) a quick flick back up after reading a
   third of the page (or two screens) with their own finger — since 2026-09-19 evening; the first build's 50 % depth / 40 s fired on the stars' jump to the
   reviews (Karol). The same wheel,
   the same open() — no new popup, no new words. Never where the tab stays away (cart / checkout / account / policy pages, after a
   spin), never while the cookie banner or any of the theme's drawers / modals is open, never when the server says the wheel is off,
   never when the browser gives no localStorage (the 30-day memory could not be kept). The section's "exit_intent" setting is the switch. On open: ONE fetch of
   <api>/spin/config (the slices' labels, kinds, colours — the server keeps the odds), the SVG wheel, the form (the consent checkbox
   when the server asks for it, a Cloudflare Turnstile widget loaded on demand). Submit = ONE POST <api>/spin; the wheel animates to
   the slice the server drew; a prize shows its code (copy button) and the "we e-mailed it" line; a losing slice its words. After a
   spin: cookie co2art_spin=done (the section's days) — the tab and the exit intent are gone for that visitor; since 2026-09-19 evening
   (Karol's form) also when the server says the address already played, and on the voucher mail's landing (a spin on another device) —
   every other refusal leaves the tab. The cookie is per host: another Markets domain can still show the wheel once. A win also gets "Apply code & shop" — Shopify's
   /discount/<code>?redirect=… link from the server (the code is applied at checkout, no typing). Errors come back as {error, message} and
   the sentence is shown as is unless the theme knows the code (co2art.spin.code_<error>). Since 2026-09-17 (Karol) the answer
   carries NO code: the win screen names the address in big type (a typo is seen; a refused address is never announced) and
   "not your address?" sends the same prize to a corrected one through POST /spin/claim with the spin's own token. GA4 events through dataLayer/gtag when present:
   spin_open, spin_played, spin_won, spin_applied. Every word comes from the section's JSON blob (<script data-i18n> — the locale file's
   co2art.spin.* keys or the editor's override, 2026-09-16 Karol's K-8); the prize labels the server sends in English are rendered by prizeLabel().
   The "voucher is in your cart" card (2026-09-16 evening, Karol): the win screen's Apply click fetches Shopify's /discount/<code>
   (redirect /cart.js) in the background, checks the discount_code cookie and swaps the dialog to the card — the page stays; a URL
   with ?spin=<code>&prize=&until= (the mail's button, via the same /discount/ redirect) opens the card on arrival, whatever the
   co2art_spin cookie says, and the URL is cleaned at once. No cookie → the result state with the code and the Apply link, never
   a false "it is in your cart". One button, Continue shopping — the person stays where they are.
   Never on cart / checkout / account / app-proxy / policy pages. Concept re-executes injected scripts on page transitions — the
   define is guarded, the element upgrades per page. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('spin-to-win')) return;

  var BROWSE = /^\/(?:$|collections|products|pages|blogs|search)/;
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeCookie(name, value, days) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + (days * 86400) + '; path=/; SameSite=Lax; Secure';
  }
  /* {{ name }} (the locale files' form, protected by the translator) or [name] (the editor's habit) — both are filled */
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{\{\s*(\w+)\s*\}\}|\[(\w+)\]/g, function (_, a, b) { var k = a || b; return map[k] != null ? map[k] : ''; });
  }
  /* `t` escapes its output; the JSON blob carries it that way — decoded ONCE here, every value lands in textContent */
  function decodeEntities(v) { return String(v == null ? '' : v).replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&#x27;/g, function (c) { return { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'" }[c]; }); }
  function slug(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }
  /* a locale served as an alternate path (bg.co2art.eu/bg) puts its root in front of every path — the page tests look past it */
  function siteRoot() { try { var r = window.Shopify && Shopify.routes && Shopify.routes.root; return (r && r !== '/') ? r.replace(/\/$/, '') : ''; } catch (e) { return ''; } }
  function pagePath() {
    var root = siteRoot(), p = location.pathname;
    if (root && p.indexOf(root) === 0) return p.slice(root.length) || '/';
    /* a served alias of the root language (bg.co2art.eu/bg/… while bg IS that domain's root — measured 2026-09-16): the first segment equals the page's language */
    var lang = String(document.documentElement.lang || (window.Shopify && Shopify.locale) || '').toLowerCase();
    var m = p.match(/^\/([a-z]{2}(?:-[a-z]{2,4})?)(\/|$)/i);
    if (lang && m && m[1].toLowerCase() === lang) return p.slice(m[1].length + 1) || '/';
    return p;
  }
  function ga(ev, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: ev }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', ev, params || {});
    } catch (e) { /* analytics never breaks the wheel */ }
  }
  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (window.__spinTurnstileLoading) return window.__spinTurnstileLoading;
    window.__spinTurnstileLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = TURNSTILE_SRC; s.async = true; s.defer = true;
      s.onload = function () { resolve(window.turnstile); };
      s.onerror = function () { reject(new Error('turnstile')); };
      document.head.appendChild(s);
    });
    return window.__spinTurnstileLoading;
  }
  function polar(cx, cy, r, deg) {
    var a = (deg - 90) * Math.PI / 180;
    return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function landingFromUrl() {
    /* the mail's button: Shopify's /discount/<code>?redirect=/?spin=… sets the cookie and lands here; the three params are read once and removed */
    try {
      var q = new URLSearchParams(location.search); var code = (q.get('spin') || '').trim().toUpperCase();
      if (!/^SPIN-[A-Z0-9]{4,10}$/.test(code)) return null;
      var l = { code: code, prize: (q.get('prize') || '').slice(0, 60), until: (q.get('until') || '').slice(0, 10) };
      ['spin', 'prize', 'until'].forEach(function (k) { q.delete(k); });
      var rest = q.toString();
      try { history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash); } catch (e) { /* nothing */ }
      return l;
    } catch (e) { return null; }
  }
  function discountCookie() {
    var v = readCookie('discount_code');
    try { return v ? decodeURIComponent(v).trim().toUpperCase() : ''; } catch (e) { return (v || '').trim().toUpperCase(); }
  }
  function fmtDate(v, locale) {
    if (!v) return '';
    try { var d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(v) ? v + 'T12:00:00Z' : v); return isNaN(d.getTime()) ? String(v) : d.toLocaleDateString(locale || undefined, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return String(v); }
  }

  /* exit intent (2026-09-19): the 30-day memory lives in localStorage; undefined = the browser gives none → the wheel never opens by itself */
  var EXIT_KEY = 'co2art_spin_exit', EXIT_DAYS = 30, EXIT_ARM_MS = 5000, VIEWS_KEY = 'co2art_spin_views';
  /* the phone's signal (2026-09-19 evening, Karol's form): a flick back up of EXIT_FLICK_PX within EXIT_FLICK_MS, once the visitor's own
     finger has been through EXIT_FLICK_DEPTH of the page or EXIT_FLICK_SCREENS screens, whichever comes first (a regulator page is ~12,000 px
     tall — a third of it is the reviews); a tap and the scroll it causes are ignored for EXIT_TAP_QUIET_MS; a scroll counts only while a
     finger is down or in the momentum after it (EXIT_MOMENTUM_MS) */
  var EXIT_FLICK_DEPTH = 0.3, EXIT_FLICK_SCREENS = 2, EXIT_FLICK_PX = 240, EXIT_FLICK_MS = 350, EXIT_TAP_QUIET_MS = 1500, EXIT_MOMENTUM_MS = 1200;
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return undefined; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); return window.localStorage.getItem(k) === String(v); } catch (e) { return false; } }
  function pageViews() {
    try { var n = (parseInt(window.sessionStorage.getItem(VIEWS_KEY), 10) || 0) + 1; window.sessionStorage.setItem(VIEWS_KEY, String(n)); return n; } catch (e) { return 1; }
  }
  /* the cookie banner (sections/cookie-banner.liquid marks the body) or any of Concept's drawers / modals (a custom element carrying `open`) */
  function overlayOpen() {
    try {
      if (document.body.classList.contains('has-cookie-banner')) return true;
      /* the banner shows after its own delay (5 s) — a visitor it is still coming for is not interrupted first: the same test the
         banner runs (assets/cookie-banner.js onConsentLibraryLoaded), only where the banner's section is on the page */
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (document.querySelector('cookie-banner') && cp && cp.getTrackingConsent && cp.getTrackingConsent() === 'no_interaction' && !cp.userCanBeTracked()) return true;
      var els = document.querySelectorAll('[open]');
      for (var i = 0; i < els.length; i++) {
        var tag = els[i].tagName.toLowerCase();
        if (tag === 'dialog' || (tag.indexOf('-') > 0 && tag !== 'spin-to-win')) return true;
      }
    } catch (e) { return true; }
    return false;
  }

  var SAMPLE = [
    { position: 0, label: 'Free Drop Checker Kit', kind: 'product', colour: '#7ed321' }, { position: 1, label: 'So close!', kind: 'losing', colour: '#d0021b' },
    { position: 2, label: '10% Off', kind: 'percent', colour: '#7ed321' }, { position: 3, label: 'No luck today.', kind: 'losing', colour: '#d0021b' },
    { position: 4, label: 'Free Flux_ Diffuser', kind: 'product', colour: '#7ed321' }, { position: 5, label: 'Sorry, try again!', kind: 'losing', colour: '#d0021b' },
    { position: 6, label: '20% Off', kind: 'percent', colour: '#7ed321' }, { position: 7, label: 'Next time!', kind: 'losing', colour: '#d0021b' },
    { position: 8, label: '15% Off', kind: 'percent', colour: '#7ed321' }, { position: 9, label: 'Almost!', kind: 'losing', colour: '#d0021b' },
    { position: 10, label: '10% Off', kind: 'percent', colour: '#7ed321' }, { position: 11, label: 'Not quite.', kind: 'losing', colour: '#d0021b' }
  ];

  class SpinToWin extends HTMLElement {
    connectedCallback() {
      this.tab = this.querySelector('[data-tab]');
      this.dialog = this.querySelector('[data-dialog]');
      this.form = this.querySelector('[data-form]');
      this.result = this.querySelector('[data-result]');
      this.applied = this.querySelector('[data-applied]');
      this.wheel = this.querySelector('[data-wheel]');
      this.rotor = this.querySelector('[data-rotor]');
      this.design = this.hasAttribute('data-design-mode');
      if (!this.tab || !this.dialog) return;
      this.locale = this.dataset.locale || document.documentElement.lang || '';
      this.t = {};
      try {
        var blob = this.querySelector('script[data-i18n]');
        var walk = function (o) { var out = {}; Object.keys(o).forEach(function (k) { out[k] = (o[k] && typeof o[k] === 'object') ? walk(o[k]) : decodeEntities(o[k]); }); return out; };
        if (blob) this.t = walk(JSON.parse(blob.textContent));
      } catch (e) { this.t = {}; }
      var landing = this.design ? null : landingFromUrl();
      /* the tab's own rules (browsing pages, one spin per visitor, fetch) — the mail's landing opens the card even where the tab stays away */
      var showTab = this.design || (BROWSE.test(pagePath()) && !readCookie(this.dataset.cookie || 'co2art_spin') && !!window.fetch);
      if (!showTab && !landing) return;
      var self = this;
      if (showTab) {
        this.tab.hidden = false;
        this.tab.addEventListener('click', function () { self.open(); });
        if (!this.design && !landing && this.dataset.exitIntent === 'true') this.armExitIntent();
      }
      this.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(); }); });
      this._esc = function (ev) { if (ev.key === 'Escape' && !self.dialog.hidden) self.close(); };
      document.addEventListener('keydown', this._esc);
      /* no `submit` event: Concept's own form handling turns a submit button into loading dots and never returns it — the button is
         type=button and Enter in the e-mail field is the click */
      var submitBtn = this.querySelector('[data-submit]');
      if (submitBtn) submitBtn.addEventListener('click', function (ev) { ev.preventDefault(); self.submit(); });
      var emailInput = this.querySelector('input[type="email"]');
      if (emailInput) emailInput.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); self.submit(); } });
      if (this.form) this.form.addEventListener('submit', function (ev) { ev.preventDefault(); ev.stopPropagation(); });
      var copy = this.querySelector('[data-copy]');
      if (copy) copy.addEventListener('click', function () { self.copyCode('[data-code]', copy); });
      var copy2 = this.querySelector('[data-copy-applied]');
      if (copy2) copy2.addEventListener('click', function () { self.copyCode('[data-applied-code]', copy2); });
      var apply = this.querySelector('[data-apply]');
      if (apply) apply.addEventListener('click', function (ev) { self.applyInPage(ev); });
      var claimOpen = this.querySelector('[data-claim-open]'), claimForm = this.querySelector('[data-claim]'), claimSubmit = this.querySelector('[data-claim-submit]');
      if (claimOpen) claimOpen.addEventListener('click', function () { self.openClaim(); });
      if (claimSubmit) claimSubmit.addEventListener('click', function (ev) { ev.preventDefault(); self.claim(); });
      if (claimForm) { claimForm.addEventListener('submit', function (ev) { ev.preventDefault(); ev.stopPropagation(); self.claim(); }); var ci = claimForm.querySelector('input'); if (ci) ci.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); self.claim(); } }); }
      if (this.design) { this.config = { enabled: true, consent_required: true, slices: SAMPLE, turnstile_site_key: '' }; this.drawWheel(SAMPLE); }
      if (landing) this.land(landing);
    }

    disconnectedCallback() {
      this.disarmExitIntent();
      if (this._esc) { document.removeEventListener('keydown', this._esc); this._esc = null; }
      document.documentElement.classList.remove('spin-open');
    }

    api(path) { return (this.dataset.api || '') + path; }

    /* Exit intent — once per visitor in EXIT_DAYS. Desktop: the pointer leaves the document through the top (towards the tabs / the
       address bar), not before EXIT_ARM_MS on the page. Phone (no hover): from the visitor's SECOND page view, a quick flick back up
       (the gesture towards the address bar / back) after their own finger read EXIT_FLICK_DEPTH of the page or EXIT_FLICK_SCREENS screens —
       never a jump a tap caused
       (the stars scroll to the reviews, an anchor, a button). A blocked attempt (cookie banner, a drawer) keeps the listeners — the next
       signal tries again. */
    armExitIntent() {
      var seen = lsGet(EXIT_KEY);
      if (seen === undefined) return;                                                  /* no storage → no memory → never by itself */
      if (seen && (Date.now() - (parseInt(seen, 10) || 0)) < EXIT_DAYS * 86400000) return;
      var self = this, views = pageViews();
      var phone = !!(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);
      this._exit = { timers: [], off: [] };
      if (phone) {
        if (views < 2) return;
        /* `travel` = how far the visitor's OWN finger moved the page down (a tap's jump to the reviews adds nothing) */
        var touching = false, touchEnd = 0, lastTap = 0, travel = 0, prev = null, trail = [];
        var onStart = function () { touching = true; };
        var onEnd = function () { touching = false; touchEnd = Date.now(); };
        var onTap = function () { lastTap = Date.now(); trail = []; };
        var onScroll = function () {
          var now = Date.now(), doc = document.documentElement, cur = window.pageYOffset || doc.scrollTop || 0;
          /* not the visitor's own finger: the scroll a tap caused, or one long after the last touch (a script, a jump) */
          if (now - lastTap < EXIT_TAP_QUIET_MS || (!touching && now - touchEnd > EXIT_MOMENTUM_MS)) { trail = []; prev = cur; return; }
          if (prev !== null && cur > prev) travel += cur - prev;
          prev = cur;
          trail.push([now, cur]);
          while (trail.length && now - trail[0][0] > EXIT_FLICK_MS) trail.shift();
          var max = doc.scrollHeight - window.innerHeight;
          if (max <= 0 || travel < Math.min(max * EXIT_FLICK_DEPTH, window.innerHeight * EXIT_FLICK_SCREENS) || trail.length < 2) return;
          var high = 0; for (var i = 0; i < trail.length; i++) high = Math.max(high, trail[i][1]);
          if (high - cur >= EXIT_FLICK_PX) { trail = []; self.exitIntent('flick'); }
        };
        window.addEventListener('touchstart', onStart, { passive: true });
        window.addEventListener('touchend', onEnd, { passive: true });
        window.addEventListener('touchcancel', onEnd, { passive: true });
        document.addEventListener('click', onTap, true);
        window.addEventListener('scroll', onScroll, { passive: true });
        this._exit.off.push(function () {
          window.removeEventListener('touchstart', onStart); window.removeEventListener('touchend', onEnd); window.removeEventListener('touchcancel', onEnd);
          document.removeEventListener('click', onTap, true); window.removeEventListener('scroll', onScroll);
        });
      } else {
        this._exit.timers.push(setTimeout(function () {
          if (!self._exit) return;
          var onOut = function (ev) { if (!ev.relatedTarget && ev.clientY <= 0) self.exitIntent('pointer'); };
          document.addEventListener('mouseout', onOut);
          self._exit.off.push(function () { document.removeEventListener('mouseout', onOut); });
        }, EXIT_ARM_MS));
      }
    }

    disarmExitIntent() {
      if (!this._exit) return;
      this._exit.timers.forEach(function (t) { clearTimeout(t); });
      this._exit.off.forEach(function (f) { try { f(); } catch (e) { /* nothing */ } });
      this._exit = null;
    }

    /* true = this signal is spent (opened, or never will); false = blocked for now, the listeners stay */
    exitIntent(signal) {
      var self = this;
      if (!this._exit || this._exitBusy) return true;
      if (!this.dialog.hidden || readCookie(this.dataset.cookie || 'co2art_spin')) { this.disarmExitIntent(); return true; }
      if (overlayOpen()) return false;
      this._exitBusy = true;
      var ready = this.config ? Promise.resolve(this.config) : fetch(this.api('/spin/config'), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('config ' + r.status); return r.json(); });
      ready.then(function (cfg) {
        self._exitBusy = false;
        if (!self._exit) return;
        if (!cfg || !cfg.enabled || !cfg.slices || !cfg.slices.length) { self.disarmExitIntent(); return; }   /* the wheel is off — nothing opens by itself */
        self.config = cfg;
        if (!self.dialog.hidden || overlayOpen()) return;
        if (!lsSet(EXIT_KEY, String(Date.now()))) { self.disarmExitIntent(); return; }
        self.disarmExitIntent();
        self.open('exit_' + signal);
      }).catch(function () { self._exitBusy = false; self.disarmExitIntent(); });
      return true;
    }

    open(trigger) {
      var self = this;
      this.dialog.hidden = false;
      document.documentElement.classList.add('spin-open');
      ga('spin_open', { store_host: location.hostname, spin_trigger: trigger || 'tab' });
      var email = this.querySelector('input[type="email"]');
      /* by itself on a phone the keyboard stays down — the visitor sees the wheel first */
      if (email && trigger !== 'exit_flick') setTimeout(function () { try { email.focus({ preventScroll: true }); } catch (e) { email.focus(); } }, 50);
      if (this.design) return;
      if (!this.config) {
        this.setError('');
        fetch(this.api('/spin/config'), { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('config ' + r.status); return r.json(); })
          .then(function (cfg) { self.config = cfg; self.applyConfig(cfg); })
          .catch(function () { self.setError(self.msg('err_config', 'The wheel is taking a break — please try again in a minute.')); self.disable(true); });
      } else {
        this.applyConfig(this.config);
      }
    }

    applyConfig(cfg) {
      var self = this;
      /* the wheel and the consent line draw whatever the switch says — a paused wheel still looks like a wheel; only the submit is held */
      this.drawWheel(cfg && cfg.slices && cfg.slices.length ? cfg.slices : SAMPLE);
      var consent = this.querySelector('[data-consent]');
      if (consent) consent.hidden = !(cfg && cfg.consent_required);
      if (!cfg || !cfg.enabled || !cfg.slices || !cfg.slices.length) { this.setError(this.msg('err_paused', 'The wheel is taking a break — please come back later.')); this.disable(true); return; }
      this.disable(false);
      var box = this.querySelector('[data-turnstile]');
      if (box && cfg.turnstile_site_key && this._widget == null) {
        loadTurnstile().then(function (ts) {
          if (self._widget != null) return;
          var lang = String(self.locale || '').toLowerCase(); if (lang && !/^zh-/.test(lang)) lang = lang.split('-')[0];
          self._widget = ts.render(box, { sitekey: cfg.turnstile_site_key, size: 'flexible', appearance: 'interaction-only', theme: 'light', language: lang || 'auto' });
        }).catch(function () { self.setError(self.msg('err_turnstile_load', 'Our bot check could not load — please reload the page.')); });
      }
    }

    drawWheel(slices) {
      if (!this.rotor) return;
      var n = slices.length, step = 360 / n, R = 96, out = [], i, win = 0, lose = 0;
      var pt = function (r, deg) { var a = (deg - 90) * Math.PI / 180; return [(r * Math.cos(a)).toFixed(2), (r * Math.sin(a)).toFixed(2)]; };
      /* the slices: prizes alternate the two greens, losing slices the two greys (B) */
      for (i = 0; i < n; i++) {
        var isWin = slices[i].kind === 'percent' || slices[i].kind === 'product';
        var cls = isWin ? (win++ % 2 ? 'win-b' : 'win-a') : (lose++ % 2 ? 'lose-b' : 'lose-a');
        var p0 = pt(R, i * step), p1 = pt(R, (i + 1) * step);
        out.push('<path class="sl ' + cls + '" data-i="' + i + '" d="M0 0 L' + p0[0] + ' ' + p0[1] + ' A' + R + ' ' + R + ' 0 0 1 ' + p1[0] + ' ' + p1[1] + ' Z"/>');
      }
      /* the labels read along the slice's middle radius; two balanced lines when long; flipped on the left half so nothing is upside down */
      for (i = 0; i < n; i++) {
        var sl = slices[i], isW = sl.kind === 'percent' || sl.kind === 'product';
        var label = this.prizeLabel(sl), words = label.split(/\s+/), lines = [label];
        if (label.length > 11 && words.length > 1) {
          var best = 1, bestDiff = 1e9;
          for (var w = 1; w < words.length; w++) { var d = Math.abs(words.slice(0, w).join(' ').length - words.slice(w).join(' ').length); if (d < bestDiff) { bestDiff = d; best = w; } }
          lines = [words.slice(0, best).join(' '), words.slice(best).join(' ')];
        }
        var longest = 0; lines.forEach(function (l) { if (l.length > longest) longest = l.length; });
        var cap = lines.length > 1 ? 8.6 : (isW ? 10 : 8.8), fs = Math.max(6.2, Math.min(cap, 70 / (longest * 0.63)));
        var c = i * step + step / 2, flip = c > 180;
        var spans;
        if (lines.length === 1) spans = esc(lines[0]);
        else {
          /* the first line sits on the text's upper side on BOTH halves: the flipped rotation already turns the text, so the line
             stack must not be mirrored again — mirrored, a left-half label read "geschafft! / Fast" (German, 2026-09-16) */
          spans = lines.map(function (l, k) { var d = (k === 0 ? -0.58 : 1.16); return '<tspan x="0" dy="' + d + 'em">' + esc(l) + '</tspan>'; }).join('');
        }
        out.push('<g class="lb ' + (isW ? 'win' : 'lose') + '" data-lb="' + i + '" transform="rotate(' + c.toFixed(2) + ') translate(0,-61) rotate(' + (flip ? 90 : -90) + ')">'
          + '<text x="0" y="0" font-size="' + fs.toFixed(2) + '" text-anchor="middle" dominant-baseline="central">' + spans + '</text></g>');
      }
      this.rotor.innerHTML = out.join('');
      this._n = n;
      /* C's marquee: 24 bulbs on the ring, three blink phases */
      var bulbs = this.querySelector('[data-bulbs]');
      if (bulbs && !bulbs.childElementCount) {
        var bo = [];
        for (i = 0; i < 24; i++) { var bp = pt(105, i * 15 + 7.5); bo.push('<circle class="bulb" cx="' + bp[0] + '" cy="' + bp[1] + '" r="4" style="animation-delay:' + ((i % 3) * 0.383).toFixed(3) + 's"/>'); }
        bulbs.innerHTML = bo.join('');
      }
    }

    setError(msg) { var el = this.querySelector('[data-error]'); if (el) el.textContent = msg || ''; }
    msg(key, fallback) { var v = this.t && this.t[key]; return (v != null && v !== '') ? v : fallback; }
    /* the server sends the prize's English label (kind + label); the locale file renders it: a percent slice through
       prize.percent_off, a product slice through prize.free_product (the product's name stays as it is), a losing slice by its slug */
    prizeLabel(sl) {
      var label = String(sl && sl.label || '').trim(), P = (this.t && this.t.prize) || {};
      if (sl && sl.kind === 'percent') { var m = label.match(/(\d+(?:[.,]\d+)?)\s*%/); if (m && P.percent_off) return fill(P.percent_off, { value: m[1] }); }
      if (sl && sl.kind === 'product') { var name = label.replace(/^\s*free\s+/i, ''); if (P.free_product && name !== label) return fill(P.free_product, { name: name }); }
      var k = slug(label); if (k && P[k]) return P[k];
      return label;
    }
    disable(on) { var b = this.querySelector('[data-submit]'); if (b) b.disabled = !!on; }

    submit() {
      var self = this;
      if (this.design || this._busy) return;
      var email = this.querySelector('input[type="email"]'), consentBox = this.querySelector('[data-consent] input');
      var addr = (email && email.value || '').trim();
      if (!addr || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { this.setError(this.msg('err_email', 'Please enter a valid e-mail address.')); if (email) email.focus(); return; }
      var needConsent = this.config && this.config.consent_required;
      var consent = !!(consentBox && consentBox.checked);
      if (needConsent && !consent) { this.setError(this.msg('err_consent', 'Please tick the box so we can e-mail you your prize.')); return; }
      var token = '';
      try { token = (window.turnstile && this._widget != null) ? (window.turnstile.getResponse(this._widget) || '') : ''; } catch (e) { token = ''; }
      if (this.config && this.config.turnstile_site_key && !token) { this.setError(this.msg('err_turnstile_wait', 'One moment — the bot check is still running. Please try again.')); return; }
      this._busy = true; this.disable(true); this.setError('');
      ga('spin_played', { store_host: location.hostname });
      fetch(this.api('/spin'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: addr, consent: consent || !needConsent, turnstile_token: token, page: location.pathname })
      }).then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) { j = null; } return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          var d = (res.body && res.body.detail) || {};
          if (!res.ok || !res.body) {
            /* a refusal the theme knows (code_<error> in the locale file) speaks the shopper's language; the server's English sentence is the fallback */
            var code = (typeof d === 'object' && d.error) || '';
            var local = code && self.t && self.t['code_' + code];
            var msg = local || (typeof d === 'object' && d.message) || (res.status >= 500 || !res.body
              ? fill(self.msg('err_server', 'The wheel hit a snag on our side ({{ status }}) — please try again in a minute.'), { status: res.status })
              : self.msg('err_network', 'We could not reach the wheel — please check your connection and try again.'));
            self.fail(msg, code);
            return;
          }
          self.spinTo(res.body, addr);
        })
        .catch(function () { self.fail(self.msg('err_network', 'We could not reach the wheel — please check your connection and try again.')); });
    }

    /* every refusal: the sentence, the button back, a fresh Turnstile token for the next try */
    fail(msg, code) {
      /* a refusal code the locale file knows (code_<error>) speaks the shopper's language, whoever calls; the server's sentence is the fallback */
      var local = code && this.t && this.t['code_' + code];
      this.setError(local || msg); this._busy = false; this.disable(false);
      try { if (window.turnstile && this._widget != null) window.turnstile.reset(this._widget); } catch (e) { /* nothing */ }
      /* an address that already played is refused with its sentence — and, since 2026-09-19 evening (Karol's form), the visitor has used the
         wheel: the tab and the exit intent go as after a spin. Every other refusal (limits, Turnstile, the server) leaves the tab. */
      if (code === 'already_played') { this.remember(); this.disarmExitIntent(); }
    }

    /* the pointer is knocked aside by every slice that passes: the loop reads the disc's REAL angle each frame, so the ticking
       slows down exactly as the wheel does — no fixed rhythm to fall out of step with (Karol 2026-09-17: "jak w kole fortuny") */
    tickPointer() {
      var flap = this.querySelector('[data-pointer]'), disc = this.querySelector('.spin-wheel__disc'), n = this._n || 12;
      if (!flap || !disc || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      var self = this, last = null, size = 360 / n;
      var angleOf = function (el) {
        var t = getComputedStyle(el).transform;
        if (!t || t === 'none') return 0;
        var m = t.match(/matrix\(([^)]+)\)/);
        if (!m) return 0;
        var p = m[1].split(',');
        return Math.atan2(parseFloat(p[1]), parseFloat(p[0])) * 180 / Math.PI;
      };
      var frame = function () {
        if (!self._spinning) { flap.classList.remove('tick'); return; }
        var deg = ((angleOf(disc) % 360) + 360) % 360;
        var slice = Math.floor(deg / size);
        if (last !== null && slice !== last) { flap.classList.remove('tick'); void flap.getBoundingClientRect(); flap.classList.add('tick'); }
        last = slice;
        requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    }

    spinTo(out, addr) {
      var self = this, n = this._n || 12, step = 360 / n;
      var target = out.position * step + step / 2;
      var jitter = (Math.random() - 0.5) * step * 0.6;
      var deg = 5 * 360 + (360 - target) + jitter;
      this.remember();
      var disc = this.querySelector('.spin-wheel__disc');
      var land = function () { var hit = self.rotor && self.rotor.querySelector('.sl[data-i="' + out.position + '"]'); if (hit) hit.classList.add('hit'); var lb = self.rotor && self.rotor.querySelector('.lb[data-lb="' + out.position + '"]'); if (lb) lb.classList.add('hitlb'); };
      if (disc) {
        disc.style.transform = 'rotate(' + deg.toFixed(2) + 'deg)';
        this._spinning = true;
        this.tickPointer();
        var done = false, finish = function () { if (done) return; done = true; self._spinning = false; land(); self.showResult(out, addr); };
        disc.addEventListener('transitionend', function once() { disc.removeEventListener('transitionend', once); finish(); });
        setTimeout(finish, 5200);
      } else {
        land(); this.showResult(out, addr);
      }
    }

    /* B's one flourish: brand-coloured confetti, only on a win, only when motion is welcome */
    confetti() {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var host = document.createElement('div'); host.className = 'spin-confetti'; this.appendChild(host);
      var cols = ['#2D7D46', '#146b5e', '#10b981', '#16161d', '#ffffff'];
      var cx = window.innerWidth / 2, cy = window.innerHeight * 0.42;
      for (var i = 0; i < 90; i++) {
        var s = document.createElement('i'); var w = 6 + Math.random() * 6;
        s.style.width = w + 'px'; s.style.height = (w * 0.6) + 'px'; s.style.background = cols[i % cols.length];
        s.style.left = cx + 'px'; s.style.top = cy + 'px'; host.appendChild(s);
        var ang = (Math.random() * 2 - 1) * Math.PI, dist = 120 + Math.random() * 320;
        var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist * 0.7 - 40;
        if (s.animate) s.animate([
          { transform: 'translate(-50%,-50%) rotate(0deg)', opacity: 1, offset: 0 }, { opacity: 1, offset: .62 },
          { transform: 'translate(' + dx + 'px,' + (dy + 140) + 'px) rotate(' + (Math.random() * 900 - 450) + 'deg)', opacity: 0, offset: 1 }
        ], { duration: 1400 + Math.random() * 800, easing: 'cubic-bezier(.16,.68,.32,1)', fill: 'forwards' });
      }
      setTimeout(function () { if (host.parentNode) host.parentNode.removeChild(host); }, 2600);
    }

    showResult(out, addr) {
      var h = this.querySelector('[data-result-heading]'), wrap = this.querySelector('[data-code-wrap]'), code = this.querySelector('[data-code]');
      var text = this.querySelector('[data-result-text]'), small = this.querySelector('[data-result-small]');
      var apply = this.querySelector('[data-apply]');
      if (apply) { if (out.won && out.apply_url) { apply.href = out.apply_url; apply.hidden = false; apply.classList.remove('is-busy'); } else { apply.hidden = true; } }
      this.lastWin = out.won ? out : null;
      var sent = this.querySelector('[data-sent]');
      if (out.won) {
        h.textContent = fill(this.msg('win', 'You won: {{ prize }}'), { prize: this.prizeLabel(out) });
        /* 2026-09-17: no code on screen — the address, big and readable, is the whole feedback; the code travels by mail only */
        this.lastSpin = { event_id: out.event_id, token: out.claim_token || '', email: out.sent_to || addr };
        code.textContent = ''; wrap.hidden = true;
        text.textContent = ''; small.textContent = '';
        if (sent) { sent.hidden = false; this.renderSent(this.lastSpin.email); }
        var claimForm = this.querySelector('[data-claim]'); if (claimForm) claimForm.hidden = true;
        ga('spin_won', { store_host: location.hostname, prize: out.label });
        this.confetti();
      } else {
        if (sent) sent.hidden = true;
        h.textContent = this.prizeLabel(out) || '';
        wrap.hidden = true;
        text.textContent = fill(this.msg('lose', '{{ prize }} No prize this time — but your welcome series with our best tips is on its way.'), { prize: '' }).trim();
        small.textContent = '';
      }
      this.form.hidden = true;
      this.result.hidden = false;
      var focus = this.result.querySelector('button'); if (focus) focus.focus();
    }

    copyCode(sel, button) {
      var code = this.querySelector(sel || '[data-code]'), btn = button || this.querySelector('[data-copy]'), self = this;
      var value = code ? code.textContent : '';
      if (!value) return;
      var done = function () { if (btn) { btn.textContent = self.msg('copied', 'Copied!'); btn.classList.add('done'); setTimeout(function () { btn.textContent = self.msg('copy', 'Copy code'); btn.classList.remove('done'); }, 1800); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(value).then(done, done);
      else { try { var r = document.createRange(); r.selectNodeContents(code); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); document.execCommand('copy'); } catch (e) { /* nothing */ } done(); }
    }

    /* the mail's landing: the cookie is already set by Shopify's redirect — the card opens; without the cookie, the code and the link */
    land(l) {
      var self = this, kind = /^\/products\//.test(pagePath()) ? 'product' : 'percent';
      /* the code's params ride OUTSIDE `redirect=` — Shopify drops the query written inside it whenever the URL carries anything else
         (the mails' utm_*); the 302 is built from the redirect PATH plus the outer query (measured 2026-09-16) */
      var back = '/discount/' + encodeURIComponent(l.code) + '?redirect=' + encodeURIComponent(location.pathname) +
                 '&spin=' + encodeURIComponent(l.code) + '&prize=' + encodeURIComponent(l.prize || '') + (l.until ? '&until=' + encodeURIComponent(l.until) : '');
      var win = { won: true, code: l.code, label: l.prize || '', expires_at: l.until || '', kind: kind, apply_url: back };
      this.remember();   /* the voucher mail's landing = a spin (perhaps on another device): no tab, no exit intent from here (Karol's form 2026-09-19) */
      this.dialog.hidden = false;
      document.documentElement.classList.add('spin-open');
      if (this.wheel) this.wheel.hidden = true;
      var panel = this.querySelector('.spin-dialog__panel'); if (panel) panel.classList.add('is-narrow');
      if (discountCookie() === l.code) { this.showApplied(win, 'email'); return; }
      this.lastWin = win;
      var h = this.querySelector('[data-result-heading]'), wrap = this.querySelector('[data-code-wrap]'), code = this.querySelector('[data-code]');
      var text = this.querySelector('[data-result-text]'), small = this.querySelector('[data-result-small]'), apply = this.querySelector('[data-apply]');
      var sentBlock = this.querySelector('[data-sent]'); if (sentBlock) sentBlock.hidden = true;
      if (h) h.textContent = fill(this.msg('win', 'You won: {{ prize }}'), { prize: this.prizeLabel(win) || win.label || '' });
      if (code) code.textContent = win.code; if (wrap) wrap.hidden = false;
      if (text) text.textContent = fill(this.msg('nocookie', 'Your browser did not keep the code. Copy it and paste it at checkout, or press the button below.'), { code: win.code });
      if (small) small.textContent = kind === 'product' ? this.msg('product_hint', 'Add the product to your cart first — the code takes its price off.')
        : (win.expires_at ? fill(this.msg('valid_until', 'It works once, until {{ date }}.'), { date: fmtDate(win.expires_at, this.locale) }) : '');
      if (apply) { apply.href = win.apply_url; apply.hidden = false; }
      if (this.form) this.form.hidden = true;
      if (this.result) this.result.hidden = false;
      var focus = this.result && this.result.querySelector('button'); if (focus) focus.focus();
      ga('spin_landed', { store_host: location.hostname, cookie: false });
      void self;
    }

    /* Apply code & shop, in place: Shopify sets the discount_code cookie on its 302 (redirect /cart.js is a cheap target); the cookie is
       the proof — only then the card. Anything else falls back to the link itself (a full navigation ending on the same card at home). */
    applyInPage(ev) {
      var win = this.lastWin;
      if (!win || !win.code) return;
      if (ev) ev.preventDefault();
      var self = this, apply = this.querySelector('[data-apply]');
      if (apply) apply.classList.add('is-busy');
      var url = '/discount/' + encodeURIComponent(win.code) + '?redirect=' + encodeURIComponent('/cart.js');
      var fallback = function () { location.href = win.apply_url || url; };
      if (!window.fetch) { fallback(); return; }
      fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function () { if (discountCookie() !== String(win.code).toUpperCase()) throw new Error('cookie'); self.showApplied(win, 'wheel'); })
        .catch(fallback);
    }

    showApplied(win, source) {
      var map = { prize: this.prizeLabel(win) || win.label || '', code: win.code || '', date: fmtDate(win.expires_at, this.locale) };
      var h = this.querySelector('[data-applied-heading]'), t = this.querySelector('[data-applied-text]'), sm = this.querySelector('[data-applied-small]'), c = this.querySelector('[data-applied-code]');
      if (h) h.textContent = fill(this.msg('applied_heading', 'Your voucher is in your cart'), map);
      if (t) t.textContent = fill(this.msg('applied_text', '{{ prize }} — code {{ code }} is saved to your cart and comes off at checkout. It works once, until {{ date }}.'), map).replace(/, until \.$/, '.');
      if (sm) sm.textContent = win.kind === 'product' ? fill(this.msg('applied_product', 'Add the {{ prize }} to your cart — the code takes its price off at checkout.'), map) : '';
      if (c) c.textContent = win.code || '';
      if (this.wheel) this.wheel.hidden = true;
      if (this.form) this.form.hidden = true;
      if (this.result) this.result.hidden = true;
      if (this.applied) this.applied.hidden = false;
      var panel = this.querySelector('.spin-dialog__panel'); if (panel) { panel.classList.add('is-narrow'); panel.classList.add('is-applied'); }
      ga('spin_applied', { store_host: location.hostname, prize: win.label, source: source });
      this.confetti();
      var focus = this.applied && this.applied.querySelector('button.button'); if (focus) focus.focus();
    }

    /* the address in big type + the note + the "not your address?" link */
    renderSent(email) {
      var lead = this.querySelector('[data-sent-lead]'), addrEl = this.querySelector('[data-sent-addr]');
      var check = this.querySelector('[data-sent-check]'), checkText = this.querySelector('[data-check-text]'), open = this.querySelector('[data-claim-open]');
      if (lead) lead.textContent = this.msg('sent_to', 'Your voucher is on its way to');
      if (addrEl) addrEl.textContent = email || '';
      /* the warning and the way to fix it sit right under the address (Karol 2026-09-17) — a wrong address is silent, so the eye must catch it here */
      if (checkText) checkText.textContent = this.msg('check_address', 'Check it — a typo means no voucher.');
      if (open) open.textContent = this.msg('edit', 'Fix it');
      if (check) check.hidden = !(this.lastSpin && this.lastSpin.token);
    }

    openClaim() {
      var form = this.querySelector('[data-claim]'), input = form && form.querySelector('input'), btn = form && form.querySelector('[data-claim-submit] .btn-text');
      if (!form) return;
      form.hidden = false;
      if (input) { input.placeholder = this.msg('claim_placeholder', 'Your e-mail'); input.value = (this.lastSpin && this.lastSpin.email) || ''; try { input.focus(); input.select(); } catch (e) { /* nothing */ } }
      if (btn) btn.textContent = this.msg('claim_button', 'Send it there');
      this.setClaimError('');
    }

    setClaimError(msg) { var el = this.querySelector('[data-claim-error]'); if (el) el.textContent = msg || ''; }

    /* POST /spin/claim: the same prize to the corrected address — the spin's own token is the key; the answer is always the same sentence */
    claim() {
      var self = this, form = this.querySelector('[data-claim]'), input = form && form.querySelector('input'), btn = form && form.querySelector('[data-claim-submit]');
      if (!form || !this.lastSpin || !this.lastSpin.token || this._claiming) return;
      var addr = (input && input.value || '').trim();
      if (!addr || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { this.setClaimError(this.msg('err_email', 'Please enter a valid e-mail address.')); if (input) input.focus(); return; }
      this._claiming = true; this.setClaimError('');
      var label = btn && btn.querySelector('.btn-text'); if (label) label.textContent = this.msg('claim_sending', 'Sending…');
      if (btn) btn.disabled = true;
      fetch(this.api('/spin/claim'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ event_id: this.lastSpin.event_id, token: this.lastSpin.token, email: addr }) })
        .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) { j = null; } return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          self._claiming = false; if (btn) btn.disabled = false; if (label) label.textContent = self.msg('claim_button', 'Send it there');
          if (!res.ok || !res.body) {
            var d = (res.body && res.body.detail) || {}; var code = (typeof d === 'object' && d.error) || '';
            self.setClaimError((code && self.t && self.t['code_' + code]) || (typeof d === 'object' && d.message) || self.msg('err_network', 'We could not reach the wheel — please check your connection and try again.'));
            return;
          }
          self.lastSpin.email = res.body.sent_to || addr;
          form.hidden = true;
          self.renderSent(self.lastSpin.email);
          var lead = self.querySelector('[data-sent-lead]'); if (lead) lead.textContent = fill(self.msg('claim_done', 'Done — your voucher is on its way to {{ email }}.'), { email: '' }).replace(/\s*\.$/, '').replace(/\s+$/, '') || self.msg('sent_to', 'Your voucher is on its way to');
          ga('spin_claim', { store_host: location.hostname });
        })
        .catch(function () { self._claiming = false; if (btn) btn.disabled = false; if (label) label.textContent = self.msg('claim_button', 'Send it there'); self.setClaimError(self.msg('err_network', 'We could not reach the wheel — please check your connection and try again.')); });
    }

    remember() {
      if (this.design) return;
      writeCookie(this.dataset.cookie || 'co2art_spin', 'done', parseInt(this.dataset.days, 10) || 365);
      if (this.tab) this.tab.hidden = true;
    }

    close() {
      this.dialog.hidden = true;
      document.documentElement.classList.remove('spin-open');
      if (this.tab && !this.tab.hidden) { try { this.tab.focus(); } catch (e) { /* nothing */ } }
    }
  }
  customElements.define('spin-to-win', SpinToWin);
})();
